import { useQuery } from '@apollo/client';
import { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import useUser from '../../../../../helpers/useUser';
import Select from '../../Select';
import _ from 'lodash';
import { useSelectFilter } from '../../helpers/useSelectFilter';
import { READ_FEEDBACK_FORMS } from './SelectFeedbackForm.query';

export const SelectFeedbackForm = ({ options, loading, ...props }) => {
  const { OrganisationID } = useUser();
  const [filter, filterProps] = useSelectFilter();

  const { data: formData, loading: formLoading } = useQuery(
    READ_FEEDBACK_FORMS,
    {
      variables: {
        //SHOULD THERE BE A FILTER FOR FORMS THAT ALREADY BELONG TO A COURSE?
        OrganisationID,
        filter,
      },
      onError: (error) => console.log(error),
    }
  );

  const groups = useMemo(() => {
    if (!formData) {
      return [];
    }
    return formData.readFeedbackForms.edges.map(({ node }) => ({
      value: node.ID,
      label: node.Title,
    }));
  }, [formData]);

  useEffect(() => {
    const { inputValue, ref } = filterProps;
    if (!formLoading && inputValue) {
      ref.current.focus();
      ref.current.onMenuOpen();
    }
    // I do not want this to activate with inputValue change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formLoading]);

  const allOptions = useMemo(() => [...options, ...groups], [options, groups]);

  return (
    <Select
      {...props}
      {...filterProps}
      options={allOptions}
      loading={formLoading || loading}
      menuPortalTarget={document.body}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
    />
  );
};

SelectFeedbackForm.defaultProps = {
  options: [],
  loading: false,
};

SelectFeedbackForm.propTypes = {
  options: PropTypes.arrayOf(PropTypes.any),
  loading: PropTypes.bool,
};

export default SelectFeedbackForm;
